





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper";

import ArrowLeft from "../resources/arrowLeft.vue";
import ArrowRight from "../resources/arrowRight.vue";

@Component({
  components: {
      ArrowLeft,
      ArrowRight
  }
})
export default class LeftController extends Vue {
    @Prop() private cloud! : string;
    @Prop() private isVisible! : boolean;
    @Prop() private isReadTable! : boolean;
    @Prop() private totalSize! : number;
    @Prop() private mode! : string;    

    @Watch("isVisible")
        changeIsVisible(){
            if(this.isVisible){
                this.open();
            }
        }

    
    private get getTotalSize(){
        var size = "";
        if(this.totalSize > 1024 * 1024){
            size = Math.round(this.totalSize / 1024 / 1024 * 10) / 10 + "MB";
        }
        else if(this.totalSize > 1024){
            size = Math.round(this.totalSize / 1024 * 10) / 10 + "KB";
        }
        else{
            size = this.totalSize + "B";
        }
        return size;
    }

//----------開閉アニメーション----------//
    openAnimate = false;
    private open() {
        this.$emit("open");
        this.openAnimate = true;
        setTimeout(() => {
            this.openAnimate = false;
        }, 150);
    }

    closeAnimate = false;
    private close() {
        this.closeAnimate = true;
        setTimeout(() => {
            this.$emit("close");
            this.closeAnimate = false;
        }, 150);
    }
//----------開閉アニメーション----------//

    private get changeStyle(){
        var style;
        if(this.isVisible){
            style = {
                width: "324px",
                left: "0px"
            };
        }
        else{
            style = {
                width: "324px",
                left: "-324px"
            };
        }
        return style;
    }

    private getBackgroundColor(cloud : string){
        var background = this.cloud == cloud ? this.userConfigSelectColor : "";
        var style = {
            backgroundColor : background
        };
        return style;
    }

    private selectCloud(cloud: string){
        this.$emit("selectCloud", cloud);
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigSelectColor(){
        return this.$store.getters.userConfigColors.buttonColorRgba;
    }

    private get backgroundColorStyle(){
        return {
            "background-color" : this.$store.getters.userConfigColors.backgroundColor
        };
    }
}
